module.exports = __webpack_public_path__ + "img/challenge.276712de.svg";